import styled from "styled-components";
import { deviceSpec } from "breakpoints";

export const StyledAnalystDash = styled.div`
  .all-filters {
    margin-left: 12px;
  }

  .analystDash-cases-filters {
    display: flex;
    justify-content: space-between;
  }

  .analystDash-cases-toolbar {
    margin-top: 1em;
    white-space: pre;
  }

  @media ${deviceSpec.isDesktop} {
    .analystDash-cases-toolbar {
    }
  }

  @media ${deviceSpec.isTablet} {
    .analystDash-cases-toolbar {
      margin-top: 0px;
      grid-template-columns: 1fr;
      padding: 0px 20px;
      margin-bottom: 0;
    }

    .rs-picker-toggle {
      font-size: 13px;
    }

    .filter-by {
      top: 2%;
      position: absolute;
      right: 35px;
    }
  }

  .fill-color {
    fill: ${({ theme }) => theme.colors.textColor} !important;
    font-weight: 550;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  
  @media ${deviceSpec.isTablet} {
    :not(:first-child) {
      margin-top: 1em;
    }
    align-items: start;
    flex-direction: column;
  }
`

export const FrameworkContainer = styled.span`
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
`